import React from "react"

function UnreadEyeIcon() {
  return (
    <span className="anticon anticon-eyeslash ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          d="M8.47628 5.52461L5.52461 8.47628C5.14544 8.09711 4.91211 7.57794 4.91211 7.00044C4.91211 5.84544 5.84544 4.91211 7.00044 4.91211C7.57794 4.91211 8.09711 5.14544 8.47628 5.52461Z"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3959 3.36578C9.37505 2.59578 8.20839 2.17578 7.00089 2.17578C4.94172 2.17578 3.02255 3.38911 1.68672 5.48911C1.16172 6.31161 1.16172 7.69411 1.68672 8.51661C2.14755 9.23995 2.68422 9.86411 3.26755 10.3658"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.91211 11.3926C5.57711 11.6726 6.28294 11.8243 7.00044 11.8243C9.05961 11.8243 10.9788 10.611 12.3146 8.51098C12.8396 7.68848 12.8396 6.30598 12.3146 5.48348C12.1221 5.18014 11.9121 4.89431 11.6963 4.62598"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.04734 7.4082C8.89568 8.2307 8.22484 8.90154 7.40234 9.0532"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.52352 8.47559L1.16602 12.8331"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8321 1.16699L8.47461 5.52449"
          stroke="currentcolor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default UnreadEyeIcon
